export * from './FacebookPixel';
export * from './GoogleTagManager';
export { eventFBP, FB_PIXEL_ID, GTM_ID, pageview, pageviewFBP };

const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

// https://github.com/vercel/next.js/discussions/20784#discussioncomment-4101864
type ExtendedWindow = Window & {
    dataLayer: Record<string, any>[];
    fbq: (...args: any[]) => void;
};

declare const window: ExtendedWindow;

const pageview = (url: string) => {
    // console.log(`pageview , pageview`);
    window.dataLayer.push({
        event: 'pageview',
        page: url
    });
};

const pageviewFBP = () => {
    // console.log(`pageviewFBP , pageviewFBP`);
    window.fbq('track', 'PageView');
};
// https://developers.facebook.com/docs/facebook-pixel/advanced/
const eventFBP = (name, options = {}) => {
    window.fbq('track', name, options);
};
